import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { HookSection } from '../components/sales/HookSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { RevelationSection } from '../components/sales/RevelationSection';
import { ProductSection } from '../components/sales/ProductSection';
import { ForWhomSection } from '../components/sales/ForWhomSection';
import { TestimonialsSection } from '../components/sales/TestimonialsSection';
import { AuthorSection } from '../components/sales/AuthorSection';
import { GuaranteeSection } from '../components/sales/GuaranteeSection';
import { OfferSection } from '../components/sales/OfferSection';
import { FAQSection } from '../components/sales/FAQSection';
import { CloseSection } from '../components/sales/CloseSection';
import { SalesNotification } from '../components/sales/SalesNotification';
export function SalesPage() {
  return <main className="w-full" style={{
    background: 'var(--cream)'
  }} data-id="element-539">
      <HeroSection data-id="element-540" />
      <HookSection data-id="element-541" />
      <ProblemSection data-id="element-542" />
      <RevelationSection data-id="element-543" />
      <ProductSection data-id="element-544" />
      <ForWhomSection data-id="element-545" />
      <TestimonialsSection data-id="element-546" />
      <AuthorSection data-id="element-547" />
      <GuaranteeSection data-id="element-548" />
      <OfferSection data-id="element-549" />
      <FAQSection data-id="element-550" />
      <CloseSection data-id="element-551" />
      <SalesNotification data-id="element-552" />
    </main>;
}